/**
 * paginatorProvider
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import Paginator from '../Paginator';

export function paginatorProvider() {
    this.$get = $get;

    function $get() {
        return {
            forFetcher: function(fetcher) {
                return new Paginator(fetcher);
            },
        };
    }
}
